/*
 * VueJS Router paths
 */

module.exports = ( Vue ) => { 
  
    var routes = [

        //Landing page route 
        { 
            path: '/home', 
            name : 'index', 

            component: require('./components/Home.vue').default

        },


        //User owned projects
        { 
            path: '/my-projects', 
            name : 'my-projects', 

            component: require('./components/Projects/MyProjects.vue').default

        },

        //User owned projects
        { 
            path: '/my-projects/:id([0-9]{1,100})', 
            name : 'project-single', 

            component: require('./components/Projects/Single.vue').default

        },

        //User profile pages
        { 
            path: '/profile/:page?', 
            name : 'profile', 

            component: require('./components/Users/Index.vue').default

        },

        //Create new project page
        { 
            path: '/add-project', 
            name : 'add-project', 

            component: require('./components/Projects/Create.vue').default

        },

        //Block all other routes 404
        { 
            path : '/*', 
            name : '404', 
            component: Vue.component( 'four-o-four', require('./components/ErrorPages/404.vue').default )
            // component: require('./components/ErrorPages/404.vue'),
        }
    ]

    return routes;
}
